/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I reuse someone else's thumbnail on my own video?`)
};

const es_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo reutilizar la miniatura de otra persona en mi propio video?`)
};

const de_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich das Thumbnail einer anderen Person für mein eigenes Video verwenden?`)
};

const nl_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag ik andermans thumbnail hergebruiken voor mijn eigen video?`)
};

const fr_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je réutiliser la miniature de quelqu’un d’autre sur ma propre vidéo ?`)
};

const it_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso riutilizzare la miniatura di qualcun altro sul mio video?`)
};

const pt_br2_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso reutilizar a thumbnail de outra pessoa no meu próprio vídeo?`)
};

const pt_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso reutilizar a miniatura de outra pessoa no meu próprio vídeo?`)
};

const ja_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他人のサムネイルを自分の動画で再利用できますか？`)
};

const zh_yt_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以在自己的视频中重复使用别人的缩略图吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq4_q", locale)
	if (locale === "en") return en_yt_hub_faq4_q(inputs)
	if (locale === "es") return es_yt_hub_faq4_q(inputs)
	if (locale === "de") return de_yt_hub_faq4_q(inputs)
	if (locale === "nl") return nl_yt_hub_faq4_q(inputs)
	if (locale === "fr") return fr_yt_hub_faq4_q(inputs)
	if (locale === "it") return it_yt_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq4_q(inputs)
	if (locale === "pt") return pt_yt_hub_faq4_q(inputs)
	if (locale === "ja") return ja_yt_hub_faq4_q(inputs)
	return zh_yt_hub_faq4_q(inputs)
};